import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import api from '@/api';
import MemberEdit from '../edit/index';
import ParentsEdit from '../parents/index';
import AddMember from '../../member/assembly/addMember/index';
import AddHandMember from '../../handMember/assembly/addMember/index';
import MemberLink from '../memberLink/index';
import { Message } from 'element-ui';
export default {
  name: 'TouristsMemberList',
  components: {
    MemberEdit: MemberEdit,
    AddMember: AddMember,
    ParentsEdit: ParentsEdit,
    MemberLink: MemberLink,
    AddHandMember: AddHandMember
  },
  data: function data() {
    return {
      parentDialogVisible: false,
      pushMessageDisable: false,
      pushMessageDialogVisible: false,
      addCurrencyDisable: false,
      addCurrencyDialogVisible: false,
      addMemberDisable: false,
      addMembeDialogVisible: false,
      memberLinkDialogVisible: false,
      addHandMemberDisable: false,
      addHandMemberDialogVisible: false,
      isSelect: this.checkauthority('tourists_select'),
      isCreate: this.checkauthority('tourists_add'),
      isUpdate: this.checkauthority('tourists_edit'),
      isDelete: this.checkauthority('tourists_del'),
      isAddMember: this.checkauthority('TouristsMemberList_open_member'),
      isExportExcel: this.checkauthority('TouristsMemberList_open_member_export'),
      isSelectMemberInfo: this.checkauthority('select_tourists_info_edit'),
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      activeName: 'default',
      selectForm: {
        registerTime: [],
        memberTime: [],
        nickName: '',
        sex: '',
        name: '',
        headUrl: '',
        phone: '',
        userName: '',
        passWord: '',
        wxMiniOpenid: '',
        loginTime: null,
        loginNum: null,
        loginDevice: '',
        province: '',
        city: '',
        area: '',
        longitude: '',
        latitude: '',
        vAuth: '',
        memberType: '',
        privateLetterNum: null,
        acceptNum: null,
        memberStartTime: null,
        memberEndTime: null,
        warningsNum: null,
        currencyNum: null,
        memberSts: null,
        createTime: null,
        memberNo: '',
        source: '',
        sortType: 1,
        startAge: null,
        endAge: null,
        education: null,
        marriage: null,
        carPurchase: null,
        buyHouse: null,
        noOrPhone: null,
        selectCitys: [],
        authentication: '',
        matchmakerName: null,
        agencyName: null,
        membership: null,
        membershipType: null,
        dedicatedToMembership: null,
        memberHandSts: null,
        isExternalAdd: null
      },
      editDisabled: false,
      dialogVisible: false,
      pageNo: 1,
      pageSize: 10,
      tableSelects: [],
      tableData: [],
      pageTotal: 0,
      centerDialogVisible: false,
      provinces: [],
      citys: [],
      sex: [],
      memberV: [],
      memberTypes: [],
      memberSources: [],
      minAges: [],
      maxAges: [],
      educations: [],
      carPurchases: [],
      buyHouses: [],
      marriages: [],
      memberSumCounts: {},
      getAuthentications: [],
      memberOccupations: []
    };
  },
  methods: {
    handleDisable: function handleDisable(row, index) {
      if (row.membershipType === '') {
        return false;
      } else {
        return true;
      }
    },
    exportMember: function exportMember() {
      var par = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        nickName: this.selectForm.nickName,
        sex: this.selectForm.sex,
        name: this.selectForm.name,
        headUrl: this.selectForm.headUrl,
        phone: this.selectForm.phone,
        userName: this.selectForm.userName,
        vAuth: this.selectForm.vAuth,
        memberType: this.selectForm.memberType,
        privateLetterNum: this.selectForm.privateLetterNum,
        acceptNum: this.selectForm.acceptNum,
        memberStartTime: this.selectForm.memberStartTime,
        memberEndTime: this.selectForm.memberEndTime,
        warningsNum: this.selectForm.warningsNum,
        currencyNum: this.selectForm.currencyNum,
        memberSts: this.selectForm.memberSts,
        memberNo: this.selectForm.memberNo,
        source: this.selectForm.source,
        sortType: this.selectForm.sortType,
        endAge: this.selectForm.endAge,
        startAge: this.selectForm.startAge,
        marriage: this.selectForm.marriage,
        carPurchase: this.selectForm.carPurchase,
        buyHouse: this.selectForm.buyHouse,
        education: this.selectForm.education,
        noOrPhone: this.selectForm.noOrPhone,
        authentication: this.selectForm.authentication,
        matchmakerName: this.selectForm.matchmakerName,
        agencyName: this.selectForm.agencyName,
        membership: this.selectForm.membership,
        membershipType: this.selectForm.membershipType,
        dedicatedToMembership: this.selectForm.dedicatedToMembership,
        memberHandSts: this.selectForm.memberHandSts,
        isExternalAdd: this.selectForm.isExternalAdd
      };
      if (this.selectForm.selectCitys.length > 0) {
        par.province = this.selectForm.selectCitys[0];
        par.city = this.selectForm.selectCitys[1];
        if (this.selectForm.selectCitys.length > 2) {
          par.area = this.selectForm.selectCitys[2];
        }
      }
      if (this.selectForm.registerTime.length >= 2) {
        par.registerStartTime = this.selectForm.registerTime[0];
        par.registerEndTime = this.selectForm.registerTime[1];
      }
      if (this.selectForm.memberTime.length >= 2) {
        par.memberSelStartTime = this.selectForm.memberTime[0];
        par.memberSelEndTime = this.selectForm.memberTime[1];
      }
      if (par.membershipType === '红娘') {
        par.membershipType = null;
        par.membership = 3;
      }
      var apiUrl = 'admin/v1/member/exportTouristsPageList';
      this.downloadUtil.excelExport(apiUrl, par, '访客用户统计表.xls');
    },
    changeMemberOccupations: function changeMemberOccupations(type) {
      return this.enums.checkEnumsValue(this.memberOccupations, type, '-');
    },
    changeAuthentications: function changeAuthentications(type) {
      return this.enums.checkEnumsValue(this.getAuthentications, type, '-');
    },
    changeVac: function changeVac(type) {
      return this.enums.checkEnumsValue(this.memberV, type, '-');
    },
    changeMemberType: function changeMemberType(type) {
      return this.enums.checkEnumsValue(this.memberTypes, type, '-');
    },
    changeSex: function changeSex(type) {
      return this.enums.checkEnumsValue(this.sex, type, '-');
    },
    addWarning: function addWarning() {
      var _this = this;
      var par = [];
      this.tableSelects.forEach(function (element) {
        par.push(element.memberId);
      });
      if (par.length === 0) {
        Message.error('请选择会员');
      } else {
        this.$confirm('确定警告该用户？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          var data = {
            memberIds: par,
            warningsNum: 1
          };
          _this.addWarningApi(data);
        }).catch(function () {
          _this.$message({
            type: 'info',
            message: '已取消修改'
          });
        });
      }
    },
    checkMemberSource: function checkMemberSource(plag) {
      if (plag == 1) {
        return '奔赴婚介';
      } else {
        return '媒大媒小';
      }
    },
    closeMemberLink: function closeMemberLink() {
      this.memberLinkDialogVisible = false;
    },
    resetMemberLink: function resetMemberLink() {
      var par = [];
      this.tableSelects.forEach(function (element) {
        par.push(element.memberId);
      });
      if (par.length === 0) {
        Message.error('请选择会员');
        return;
      }
      this.memberLinkDialogVisible = true;
      this.$refs.memberLink.setTitle('关联账号');
      this.$refs.memberLink.initData(par);
    },
    openHandAddMember: function openHandAddMember() {
      var par = [];
      this.tableSelects.forEach(function (element) {
        par.push(element.memberId);
      });
      if (par.length === 0) {
        Message.error('请选择会员');
        return;
      }
      this.addHandMemberDialogVisible = true;
      this.$refs.addHandMember.setTitle('开通牵手');
      this.$refs.addHandMember.initData(par);
    },
    openAddMember: function openAddMember() {
      var par = [];
      this.tableSelects.forEach(function (element) {
        par.push(element.memberId);
      });
      if (par.length === 0) {
        Message.error('请选择会员');
        return;
      }
      this.addMembeDialogVisible = true;
      this.$refs.addMember.setTitle('开通会员');
      this.$refs.addMember.initData(par);
    },
    removeMember: function removeMember() {
      var _this2 = this;
      var par = [];
      this.tableSelects.forEach(function (element) {
        par.push(element.memberId);
      });
      if (par.length === 0) {
        Message.error('请选择要删除的会员');
        return;
      }
      this.$confirm('确定删除这些用户吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this2.removeMemberApi(par);
      }).catch(function () {
        _this2.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    removeMemberApi: function removeMemberApi(memberIds) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var par;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              par = {
                memberIds: memberIds
              };
              _context.n = 1;
              return api.batchRemoveMember(par);
            case 1:
              _this3.$message.success('操作成功');
              _this3.initTableData();
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    addHandMemberClose: function addHandMemberClose() {
      this.addHandMemberDialogVisible = false;
    },
    addMemberClose: function addMemberClose() {
      this.addMembeDialogVisible = false;
    },
    openPushMessage: function openPushMessage() {
      var par = [];
      this.tableSelects.forEach(function (element) {
        par.push(element.memberId);
      });
      if (par.length === 0) {
        Message.error('请选择会员');
        return;
      }
      this.pushMessageDialogVisible = true;
      this.$refs.pushMessage.setTitle('推送消息');
      this.$refs.pushMessage.initMemberData(par);
    },
    pushMessageClose: function pushMessageClose() {
      this.pushMessageDialogVisible = false;
    },
    openAddCurrency: function openAddCurrency() {
      var par = [];
      this.tableSelects.forEach(function (element) {
        par.push(element.memberId);
      });
      if (par.length === 0) {
        Message.error('请选择会员');
        return;
      }
      this.addCurrencyDialogVisible = true;
      this.$refs.addCurrency.setTitle('增币');
      this.$refs.addCurrency.initData(par);
    },
    addCurrencyClose: function addCurrencyClose() {
      this.addCurrencyDialogVisible = false;
    },
    sortChange: function sortChange(op) {
      this.pageNo = 1;
      if (op === 'default') {
        this.selectForm.sortType = 1;
      } else if (op === 'activity') {
        this.selectForm.sortType = 2;
      } else if (op === 'fans') {
        this.selectForm.sortType = 3;
      } else if (op === 'recharge') {
        this.selectForm.sortType = 4;
      }
      this.initTableData();
    },
    initEunmData: function initEunmData() {
      var thiz = this;
      this.getSexEnumList('member_sex');
      this.getMemberVList('member_v');
      this.getMemberTypeList('member_type');
      this.getMemberSourcesList('member_source');
      this.getMemberAgeEnumList();
      this.getEducationsEnumList();
      this.getBuyHousesEnumList();
      this.getMarriagesEnumList();
      this.getCarPurchasesEnumList();
      this.enums.getAuthentication(function (res) {
        thiz.getAuthentications = res.body;
      });
      this.enums.getMemberOccupations(function (arg) {
        thiz.memberOccupations = arg.body;
      });
    },
    getCarPurchasesEnumList: function getCarPurchasesEnumList() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var par, res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              par = {
                name: 'member_car_select'
              };
              _context2.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context2.v;
              _this4.carPurchases = res.body;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    getMarriagesEnumList: function getMarriagesEnumList() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var par, res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              par = {
                name: 'mbmber_marriage_select'
              };
              _context3.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context3.v;
              _this5.marriages = res.body;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    getBuyHousesEnumList: function getBuyHousesEnumList() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var par, res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              par = {
                name: 'member_buyHouse_select'
              };
              _context4.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context4.v;
              _this6.buyHouses = res.body;
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    getEducationsEnumList: function getEducationsEnumList() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var par, res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              par = {
                name: 'mbmber_education_select'
              };
              _context5.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context5.v;
              _this7.educations = res.body;
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    getMemberAgeEnumList: function getMemberAgeEnumList() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var par, res, data, index, item, values, min, max, datas, i;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              par = {
                name: 'member_age_select'
              };
              _context6.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context6.v;
              data = res.body;
              for (index in data) {
                item = data[index];
                values = item.values.split('-');
                min = values[0];
                max = values[1];
                datas = [];
                for (i = parseInt(min); i <= parseInt(max); i++) {
                  datas.push(i);
                }
                if (item.keys === 'max') {
                  _this8.maxAges = datas;
                } else {
                  _this8.minAges = datas;
                }
              }
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    getMemberSourcesList: function getMemberSourcesList(name) {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var par, res;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              par = {
                name: name
              };
              _context7.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context7.v;
              _this9.memberSources = res.body;
            case 2:
              return _context7.a(2);
          }
        }, _callee7);
      }))();
    },
    getMemberTypeList: function getMemberTypeList(name) {
      var _this0 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var par, res;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              par = {
                name: name
              };
              _context8.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context8.v;
              _this0.memberTypes = res.body;
            case 2:
              return _context8.a(2);
          }
        }, _callee8);
      }))();
    },
    getMemberVList: function getMemberVList(name) {
      var _this1 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var par, res;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              par = {
                name: name
              };
              _context9.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context9.v;
              _this1.memberV = res.body;
            case 2:
              return _context9.a(2);
          }
        }, _callee9);
      }))();
    },
    getSexEnumList: function getSexEnumList(name) {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        var par, res;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              par = {
                name: name
              };
              _context0.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context0.v;
              _this10.sex = res.body;
            case 2:
              return _context0.a(2);
          }
        }, _callee0);
      }))();
    },
    dalete: function dalete(index, data) {
      var _this11 = this;
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this11.daleteApi(index, data);
      }).catch(function () {
        _this11.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    daleteApi: function daleteApi(index, data) {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
        var par;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              par = {
                memberId: data.memberId
              };
              _context1.n = 1;
              return api.DELETE_MEMBER(par);
            case 1:
              _this12.initTableData();
            case 2:
              return _context1.a(2);
          }
        }, _callee1);
      }))();
    },
    deleteBatchApi: function deleteBatchApi(par) {
      var _this13 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              _context10.n = 1;
              return api.DELETE_BATCH_MEMBER(par);
            case 1:
              _this13.$message.success('操作成功');
              _this13.initTableData();
            case 2:
              return _context10.a(2);
          }
        }, _callee10);
      }))();
    },
    deleteBatch: function deleteBatch() {
      var _this14 = this;
      if (this.tableSelects.length === 0) {
        this.$message.error('请勾选要删除的表格数据');
        return;
      }
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var par = [];
        _this14.tableSelects.forEach(function (element) {
          par.push(element.memberId);
        });
        _this14.deleteBatchApi(par);
      }).catch(function () {
        _this14.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    info: function info(index, data) {
      this.editDisabled = true;
      this.dialogVisible = true;
      this.$refs.edit.setTitle('访客详情');
      this.$refs.edit.setData(data);
    },
    edit: function edit(index, data) {
      this.dialogVisible = true;
      this.editDisabled = false;
      this.$refs.edit.setTitle('编辑');
      this.$refs.edit.setData(data);
    },
    toAdd: function toAdd() {
      this.$refs.edit.setTitle('新增');
      this.editDisabled = false;
      this.dialogVisible = true;
      this.$refs.edit.initData();
    },
    userEditClose: function userEditClose() {
      this.dialogVisible = false;
    },
    toParents: function toParents(data) {
      this.$refs.parents.setTitle('访客详情');
      this.editDisabled = true;
      this.parentDialogVisible = true;
      this.$refs.parents.setData(data);
    },
    parentsEditClose: function parentsEditClose() {
      this.parentDialogVisible = false;
    },
    reset: function reset() {
      this.pageNo = 1;
      this.selectForm.endAge = null;
      this.selectForm.startAge = null;
      this.selectForm.registerTime = [];
      this.selectForm.memberTime = [];
      this.selectForm.nickName = '';
      this.selectForm.sex = '';
      this.selectForm.name = '';
      this.selectForm.headUrl = '';
      this.selectForm.phone = '';
      this.selectForm.userName = '';
      this.selectForm.passWord = '';
      this.selectForm.wxMiniOpenid = '';
      this.selectForm.loginTime = null;
      this.selectForm.loginNum = null;
      this.selectForm.loginDevice = '';
      this.selectForm.province = '';
      this.selectForm.city = '';
      this.selectForm.area = '';
      this.selectForm.longitude = '';
      this.selectForm.latitude = '';
      this.selectForm.vAuth = '';
      this.selectForm.memberType = '';
      this.selectForm.privateLetterNum = null;
      this.selectForm.acceptNum = null;
      this.selectForm.memberStartTime = null;
      this.selectForm.memberEndTime = null;
      this.selectForm.warningsNum = null;
      this.selectForm.currencyNum = null;
      this.selectForm.memberSts = null;
      this.selectForm.createTime = null;
      this.selectForm.memberNo = '';
      this.selectForm.source = '';
      this.selectForm.marriage = '';
      this.selectForm.carPurchase = '';
      this.selectForm.buyHouse = '';
      this.selectForm.education = '';
      this.selectForm.noOrPhone = '';
      this.selectForm.selectCitys = [];
      this.selectForm.authentication = '';
      this.selectForm.matchmakerName = null;
      this.selectForm.agencyName = null;
      this.selectForm.membership = null;
      this.selectForm.membershipType = null;
      this.selectForm.dedicatedToMembership = null;
      this.selectForm.memberHandSts = null;
      this.selectForm.isExternalAdd = null;
      this.initTableData();
    },
    search: function search() {
      this.pageNo = 1;
      this.initTableData();
    },
    initTableData: function initTableData() {
      var _this15 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11() {
        var par, res;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.n) {
            case 0:
              par = {
                pageNo: _this15.pageNo,
                pageSize: _this15.pageSize,
                nickName: _this15.selectForm.nickName,
                sex: _this15.selectForm.sex,
                name: _this15.selectForm.name,
                headUrl: _this15.selectForm.headUrl,
                phone: _this15.selectForm.phone,
                userName: _this15.selectForm.userName,
                vAuth: _this15.selectForm.vAuth,
                memberType: _this15.selectForm.memberType,
                privateLetterNum: _this15.selectForm.privateLetterNum,
                acceptNum: _this15.selectForm.acceptNum,
                memberStartTime: _this15.selectForm.memberStartTime,
                memberEndTime: _this15.selectForm.memberEndTime,
                warningsNum: _this15.selectForm.warningsNum,
                currencyNum: _this15.selectForm.currencyNum,
                memberSts: _this15.selectForm.memberSts,
                memberNo: _this15.selectForm.memberNo,
                source: _this15.selectForm.source,
                sortType: _this15.selectForm.sortType,
                endAge: _this15.selectForm.endAge,
                startAge: _this15.selectForm.startAge,
                marriage: _this15.selectForm.marriage,
                carPurchase: _this15.selectForm.carPurchase,
                buyHouse: _this15.selectForm.buyHouse,
                education: _this15.selectForm.education,
                noOrPhone: _this15.selectForm.noOrPhone,
                authentication: _this15.selectForm.authentication,
                matchmakerName: _this15.selectForm.matchmakerName,
                agencyName: _this15.selectForm.agencyName,
                membership: _this15.selectForm.membership,
                membershipType: _this15.selectForm.membershipType,
                dedicatedToMembership: _this15.selectForm.dedicatedToMembership,
                memberHandSts: _this15.selectForm.memberHandSts,
                isExternalAdd: _this15.selectForm.isExternalAdd
              };
              if (_this15.selectForm.selectCitys.length > 0) {
                par.province = _this15.selectForm.selectCitys[0];
                par.city = _this15.selectForm.selectCitys[1];
                if (_this15.selectForm.selectCitys.length > 2) {
                  par.area = _this15.selectForm.selectCitys[2];
                }
              }
              if (_this15.selectForm.registerTime.length >= 2) {
                par.registerStartTime = _this15.selectForm.registerTime[0];
                par.registerEndTime = _this15.selectForm.registerTime[1];
              }
              if (_this15.selectForm.memberTime.length >= 2) {
                par.memberSelStartTime = _this15.selectForm.memberTime[0];
                par.memberSelEndTime = _this15.selectForm.memberTime[1];
              }
              debugger;
              if (par.membershipType === '红娘') {
                par.membershipType = null;
                par.membership = 3;
              }
              _context11.n = 1;
              return api.GET_MEMBER_Tourists_PAGE_LIST(par);
            case 1:
              res = _context11.v;
              _this15.tableData = res.body.datas;
              _this15.pageTotal = res.body.sumDataCount;
            case 2:
              return _context11.a(2);
          }
        }, _callee11);
      }))();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.initTableData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNo = val;
      this.initTableData();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.tableSelects = val;
    },
    initProvinces: function initProvinces() {
      var _this16 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12() {
        var res;
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.n) {
            case 0:
              _context12.n = 1;
              return api.GET_PROVINCE_LIST();
            case 1:
              res = _context12.v;
              _this16.provinces = res.body;
            case 2:
              return _context12.a(2);
          }
        }, _callee12);
      }))();
    },
    initCitys: function initCitys() {
      var _this17 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13() {
        var res;
        return _regenerator().w(function (_context13) {
          while (1) switch (_context13.n) {
            case 0:
              _context13.n = 1;
              return api.GET_BYCITYOPENING_SELECT_TREE_LIST({});
            case 1:
              res = _context13.v;
              _this17.citys = res.body;
            case 2:
              return _context13.a(2);
          }
        }, _callee13);
      }))();
    },
    addWarningApi: function addWarningApi(data) {
      var _this18 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14() {
        return _regenerator().w(function (_context14) {
          while (1) switch (_context14.n) {
            case 0:
              _context14.n = 1;
              return api.ADD_MEMBER_WARNING(data);
            case 1:
              Message.success('操作成功');
              _this18.initTableData();
            case 2:
              return _context14.a(2);
          }
        }, _callee14);
      }))();
    },
    getMemberSumCounts: function getMemberSumCounts() {
      var _this19 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15() {
        var res;
        return _regenerator().w(function (_context15) {
          while (1) switch (_context15.n) {
            case 0:
              _context15.n = 1;
              return api.GET_MEMBER_SUM_COUNT();
            case 1:
              res = _context15.v;
              _this19.memberSumCounts = res.body;
            case 2:
              return _context15.a(2);
          }
        }, _callee15);
      }))();
    }
  },
  created: function created() {
    if (this.isSelect) {
      return;
    }
    // this.getMemberSumCounts()
    this.initCitys();
    this.initEunmData();
    this.initTableData();
  }
};